$(document).ready(function(){
  
$(".banner_slider .banner_list").slick({
  dots: true,
  infinite: true,
  arrows: false,
  speed: 1500,
  slidesToShow: 1,
  adaptiveHeight: true,
});

$('.new_featured_collection .product_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
     {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 401,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.customer_review .customer_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  

});

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll('.category_item');
    const defaultIndex = 2;

    // Add active class to the third item by default
    if (items[defaultIndex]) {
      items[defaultIndex].classList.add('active');
    }

    items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        items.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
      });

      item.addEventListener('mouseleave', () => {
        items.forEach(i => i.classList.remove('active'));
        if (items[defaultIndex]) {
          items[defaultIndex].classList.add('active');
        }
      });
    });
  });
